import { render } from "./RefferalPayout.vue?vue&type=template&id=66cb9c35"
import script from "./RefferalPayout.vue?vue&type=script&lang=js"
export * from "./RefferalPayout.vue?vue&type=script&lang=js"

import "./RefferalPayout.vue?vue&type=style&index=0&id=66cb9c35&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__